import { GoogleProvider, firebaseHandler } from '@/libs/firebase';

type LoginWithCredentialArgs = {
	email:    string;
	password: string;
};

type ResetPasswordArgs = {
	oobCode:  string;
	password: string;
};

type ChangePasswordArgs = {
	email:       string;
	password:    string;
	newPassword: string;
};

export async function loginWithCredential({ email, password }: LoginWithCredentialArgs) {
	const userCredential = await firebaseHandler.signInWithEmail(email, password);

	return userCredential;
}

export async function loginWithProvider(isForceRefresh: boolean) {
	const userCredential = await firebaseHandler.signInWithProvider(GoogleProvider);
	const idToken = await userCredential.user.getIdToken(isForceRefresh);

	return {
		user: userCredential.user,
		idToken,
	};
}

export async function resetPassword({ oobCode, password }: ResetPasswordArgs) {
	await firebaseHandler.resetPassword(oobCode, password);
}

export async function updatePassword({ email, password, newPassword }: ChangePasswordArgs) {
	await firebaseHandler.updatePassword(email, password, newPassword);
}

export async function logout() {
	await firebaseHandler.logout();
}